import React, { Component } from "react";
import { connect } from "react-redux";
import { StatusALert } from "../StatusAlert/StatusAlert";
import { Button } from "primereact/button";
import TranslationFile from "../Translation/Translation_corp.json";
import ContactUs from "../ContactUs/ContactUs";
import Footer from "../Footerpage/Footer";
import "./CorporatePage.css";
import $ from "jquery";
import axios from "axios";
// import Lap from "../../Assests/blue-print-with-laptop-copy-space.jpg";
import Lap from "../../Assests/carouselNew1_ReSized.webp";
import { Helmet } from "react-helmet";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import ImageSlider from "../ImageSlider/ImageSlider";
import config from "../../Configuration/Config";
import CMSTranslationFile from "./CorpPage_Translation_Corp.json";

const mapStateToProps = (state) => {
  return {
    sessionDetails: state.sessionDetails
  };
};

let userSelectedLanguage;
class CorporatePage extends Component {
  constructor(props) {
    super(props);
    this.contactRef = React.createRef();
    this.whyRSRef = React.createRef();
    this.pricePolicyRef = React.createRef();
    this.dataSecRef = React.createRef();
    this.servicesRef = React.createRef();

    this.state = {
      isNavExpanded: false,
      dummy: false,
      matches: window.matchMedia("(min-width: 1019px)").matches,
      sidebarVisible: false,
      color: false,
      basicPrice: ""
    };
  }

  refresh() {
    setTimeout(() => {
      window.location.reload(false);
    }, 10);
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    $(document).ready(function () {
      $(window).scroll(function () {
        var height = $(".first-container").height();
        var scrollTop = $(window).scrollTop();

        if (scrollTop >= height - 40) {
          $(".nav-container").addClass("solid-nav");
        } else {
          $(".nav-container").removeClass("solid-nav");
        }
      });
    });
  }

  componentDidMount() {
    setTimeout(() => {
      this.scrollTo();
    }, 10);
    axios.get("/siteOwner/getTemplatePackages").then((response) => {
      let getFilteredPackagesList = response.data.filter(
        (obj) => obj.visibleInGrid
      );

      // const getlowestPriceObject = getFilteredPackagesList.reduce(
      //   (prev, current) => {
      //     return prev.price < current.price ? prev : current;
      //   }
      // );

      const getlowestPriceObject = getFilteredPackagesList[0];

      this.setState({
        basicPrice: getlowestPriceObject.price
      });
    });
  }

  annualReport() {
    const { sessionDetails } = this.props;
    const { activeSideBar } = this.props;
    let selectedSideBar = [];

    setTimeout(() => {
      sessionDetails["sessionDetails"].values.currentPage = "companyInfo";
      sessionDetails["sessionDetails"].values.IsAnnualReportSubmitted = false;

      const annualReport = "/annualreport/";
      let sessionUUIDFromLS = localStorage.getItem("sessionUUID");
      window.location.href =
        config.apps.url +
        "#" +
        annualReport +
        sessionUUIDFromLS +
        "/companyInfo";

      // this.props.history.push(
      //   annualReport +
      //     sessionDetails["sessionDetails"].values.uuid +
      //     "/companyInfo"
      // );
    }, 1000);
  }

  scrollTo() {
    let currentPageUrl = window.location.href;
    let splitCurrentPageUrl = currentPageUrl.split("/");
    if (splitCurrentPageUrl[splitCurrentPageUrl.length - 2] == "contact-us") {
      if (!this.contactRef.current) return;
      this.contactRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });

      $(".corp-body").removeClass("open-menu");
      $(".hamburger-menu .bar").removeClass("animate");
    } else if (
      splitCurrentPageUrl[splitCurrentPageUrl.length - 2] == "data-security" ||
      splitCurrentPageUrl[splitCurrentPageUrl.length - 2] ==
        "customer-references" ||
      splitCurrentPageUrl[splitCurrentPageUrl.length - 2] == "for-investors"
    ) {
      if (!this.dataSecRef.current) return;
      this.dataSecRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
      $(".corp-body").removeClass("open-menu");
      $(".hamburger-menu .bar").removeClass("animate");
    } else if (
      splitCurrentPageUrl[splitCurrentPageUrl.length - 2] ==
        "for-accounting-companies" ||
      splitCurrentPageUrl[splitCurrentPageUrl.length - 2] ==
        "microsoft-business-central-development"
    ) {
      if (!this.servicesRef.current) return;
      this.servicesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center"
      });
      $(".corp-body").removeClass("open-menu");
      $(".hamburger-menu .bar").removeClass("animate");
    }
    // else if (
    //   splitCurrentPageUrl[splitCurrentPageUrl.length - 1] ==
    //   "about-us#why-rebelSkool"
    // ) {
    //   if (!this.whyRSRef.current) return;
    //   this.whyRSRef.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "center",
    //     inline: "center",
    //   });
    //   $(".corp-body").removeClass("open-menu");
    //   $(".hamburger-menu .bar").removeClass("animate");
    // } else if (
    //   splitCurrentPageUrl[splitCurrentPageUrl.length - 1] ==
    //   "about-us#Price-Policy"
    // ) {
    //   if (!this.pricePolicyRef.current) return;
    //   this.pricePolicyRef.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "center",
    //     inline: "center",
    //   });
    //   $(".corp-body").removeClass("open-menu");
    //   $(".hamburger-menu .bar").removeClass("animate");
    // }
  }

  showStatusAlertFunc = (val) => {
    this.props.showStatusAlertFunc(true);
  };

  callback = () => {
    this.scrollTo();
    this.setState({
      reRender: true
    });
  };

  render() {
    const { basicPrice } = this.state;

    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }

    return (
      <div style={{ overflow: "hidden" }}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconCorpText[userSelectedLanguage]
              : TranslationFile.FaviconCorpText.en}
          </title>
        </Helmet>
        <div>
          <HeaderNavBar
            callBack={this.callback}
            isAppPortal={false}
            isCorpPortal={true}
            isHomePage={false}
          />
        </div>

        <div className="image-container">
          <img src={Lap} alt="Sample" className="image" />
          <div className="image-text">
            <div className="home-banner-title">
              {TranslationFile.carouselTitle[userSelectedLanguage]}
            </div>

            <div className="home-banner-description">
              {TranslationFile.carouselParagraph1[userSelectedLanguage]}
            </div>

            <div className="home-banner-price">
              {TranslationFile.onlyfor[userSelectedLanguage]} {basicPrice} kr
            </div>

            <div className="home-banner-button-div">
              <Button
                onClick={() => this.annualReport()}
                className="home-banner-button"
              >
                {TranslationFile.NavbarTryForFree[userSelectedLanguage]}
              </Button>
            </div>
          </div>
        </div>
        {/* ------------------------------------------------------------------- */}

        <div className="about-div-home">
          <ImageSlider />
        </div>

        {/* ------------------------------------------------------------------- */}

        <div
          class="about-service"
          //  ref={this.servicesRef}
        >
          <div>
            <div>
              <h4>
                {/* For Accounting Companies */}
                {CMSTranslationFile.Accounting_Title1[userSelectedLanguage]}
              </h4>
            </div>
            <div className="about-service-paraDiv">
              {CMSTranslationFile.Accounting_Text1[userSelectedLanguage]}
              <a
                href={
                  "mailto:" +
                  "" +
                  CMSTranslationFile.Accounting_Email_Link[
                    userSelectedLanguage
                  ].replace(/[()]/g, "")
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "blue" }}
              >
                {CMSTranslationFile.Accounting_Email_Link[userSelectedLanguage]}
              </a>

              {/* <span> {CMSTranslationFile.Accounting_Email_Link[userSelectedLanguage]}</span> */}
              {CMSTranslationFile.Accounting_Text2[userSelectedLanguage]}
            </div>
          </div>
        </div>

        {/* ------------------------------------------------------------------ */}
        <div className="services-section" ref={this.dataSecRef}>
          <h2>
            {/* FAQ / References */}
            {CMSTranslationFile.FooterFAQReferences[userSelectedLanguage]}
          </h2>
          <div className="services-list">
            <div className="service-item">
              <h3>
                {/* Data Security */}
                {CMSTranslationFile.DS_GDPR_Title[userSelectedLanguage]}
              </h3>
              <p>
                {CMSTranslationFile.DS_GDPR_Text1[userSelectedLanguage]}
                <a
                  href={CMSTranslationFile.DS_GDPR_Link[
                    userSelectedLanguage
                  ].replace(/[()]/g, "")}
                  target="_self"
                  rel="noopener noreferrer"
                  style={{ color: "blue" }}
                >
                  {CMSTranslationFile.DS_GDPR_Text2[userSelectedLanguage]}
                </a>

                {/* <a href="/data-security">more details</a> */}
              </p>
            </div>

            <div className="service-item">
              <h3>
                {/* References */}
                {CMSTranslationFile.References_Title[userSelectedLanguage]}
              </h3>
              <p>
                {CMSTranslationFile.References_Text1[userSelectedLanguage]}
                <a
                  href={CMSTranslationFile.References_Link[
                    userSelectedLanguage
                  ].replace(/[()]/g, "")}
                  target="_self"
                  rel="noopener noreferrer"
                  style={{ color: "blue" }}
                >
                  {CMSTranslationFile.References_Text2[userSelectedLanguage]}
                </a>
              </p>
            </div>
            <div className="service-item">
              <h3>
                {/* For Investors */}
                {CMSTranslationFile.Investors_Title[userSelectedLanguage]}
              </h3>
              <p>
                {CMSTranslationFile.Investors_Text1[userSelectedLanguage]}
                <a
                  href={CMSTranslationFile.Investors_Link[
                    userSelectedLanguage
                  ].replace(/[()]/g, "")}
                  target="_self"
                  rel="noopener noreferrer"
                  style={{ color: "blue" }}
                >
                  {CMSTranslationFile.Investors_Text2[userSelectedLanguage]}
                </a>
                {/* <a href="/for-investors">more details</a> */}
              </p>
            </div>
            {/* Add more service items as needed */}
          </div>
        </div>

        <div ref={this.contactRef}>
          <ContactUs />
        </div>
        <ScrolltoTop />
        <Footer isCorpPortal={true} />
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(CorporatePage);
